import React, { useState } from "react";
import axios from "axios";
import {
  Lock,
  Loader2,
} from "lucide-react";
import {
  API,
  TOKEN_KEY,
  ROLE_KEY,
  ROLE_LABEL_KEY,
  AREAS_KEY,
} from "./shared";

export function Login({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem(TOKEN_KEY, res.data.token);
      localStorage.setItem(ROLE_KEY, "super_admin");
      localStorage.setItem(ROLE_LABEL_KEY, "Owner");
      localStorage.removeItem(AREAS_KEY);
      onSuccess();
    } catch {
      // Owner login failed — try a staff account (email + password)
      try {
        const res2 = await axios.post(`${API}/staff/login`, {
          email: username.trim().toLowerCase(),
          password,
        });
        localStorage.setItem(TOKEN_KEY, res2.data.token);
        localStorage.setItem(ROLE_KEY, res2.data.staff.role);
        localStorage.setItem(ROLE_LABEL_KEY, res2.data.staff.role_label);
        localStorage.setItem(AREAS_KEY, JSON.stringify(res2.data.staff.areas));
        localStorage.setItem("soarlife-admin-email", res2.data.staff.email);
        onSuccess();
      } catch (e3) {
        setErr(e3?.response?.data?.detail || "Login failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#3F5043] flex items-center justify-center p-5">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm bg-[#F8F7F3] rounded-3xl p-8 shadow-2xl"
      >
        <div className="flex flex-col items-center mb-7">
          <div className="w-14 h-14 rounded-full bg-[#3F5043] flex items-center justify-center mb-4">
            <Lock size={20} className="text-[#AE8F78]" />
          </div>
          <div className="font-serif italic text-3xl text-[#3F5043]">
            Soarlife Admin
          </div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#899480] font-semibold mt-1">
            Private Dashboard
          </div>
        </div>
        <label className="block text-xs uppercase tracking-[0.22em] text-[#899480] font-semibold mb-2">
          Username
        </label>
        <input
          data-testid="admin-username-input"
          type="text"
          required
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Team username"
          className="w-full bg-[#EDEDEE] rounded-2xl px-4 py-3 text-sm text-[#3F5043] placeholder-[#3F5043]/50 focus:outline-none focus:ring-2 focus:ring-[#899480] mb-4"
        />
        <label className="block text-xs uppercase tracking-[0.22em] text-[#899480] font-semibold mb-2">
          Password
        </label>
        <input
          data-testid="admin-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter admin password"
          className="w-full bg-[#EDEDEE] rounded-2xl px-4 py-3 text-sm text-[#3F5043] placeholder-[#3F5043]/50 focus:outline-none focus:ring-2 focus:ring-[#899480]"
        />
        {err && (
          <div
            data-testid="admin-login-error"
            className="mt-3 text-sm text-[#875F45] bg-[#875F45]/10 border border-[#875F45]/30 rounded-xl px-3 py-2"
          >
            {err}
          </div>
        )}
        <button
          type="submit"
          data-testid="admin-login-btn"
          disabled={loading}
          className="mt-5 w-full inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 bg-[#3F5043] text-[#F8F7F3] text-sm font-medium hover:bg-[#875F45] transition-colors disabled:opacity-60"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : "Sign in"}
        </button>
        <a
          href="/"
          className="block mt-5 text-center text-xs uppercase tracking-[0.22em] text-[#899480] hover:text-[#3F5043]"
        >
          ← Back to site
        </a>
      </form>
    </div>
  );
}
